module.exports = __webpack_public_path__ + "img/nodata.fc2c04b3.png";